<script>
  import { createEventDispatcher } from 'svelte';
  import Modal from '@components/Modal.svelte';
  import AddRecExternalModal from '@app-components/modal/AddRecExternalModal.svelte';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');
  let sectionsStore = getGroupStore('sectionsStore');
  let recsStore = getGroupStore('recsStore');
  import { getCurrentUserStore } from '@stores/current_user';
  import BrowserUtils from '@utils/browser-utils';
  import ComponentEvents from '@utils/component-events';
  import SectionAjax from '@ajax/section';
  import RecAjax from '@ajax/rec';

  import jQuery from 'jquery';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let quizQuestion = null;
  let currentUser = getCurrentUserStore('default');
  let group = groupStore;

  export let addRecModal = false;

  let close = function () {
    addRecModal = false;
    showModal = false;

    dispatch('close');
  };

  let addedRec = async function (e) {
    dispatch('added-rec');
    let resp = e.detail;
    let elem = jQuery(`[data-rec-object-id="${resp.rec_object_id}"]`)[0];

    await BrowserUtils.goToElement(elem, {
      block: 'center',
    });

    ComponentEvents.trigger('refresh-broken-owl');
    close();
  };

  let goToSection = async function (section) {
    await BrowserUtils.goToElement(jQuery(`[data-section-id="${section.id}"]`).closest('.ui-section')[0], {
      block: 'start',
      inline: 'nearest',
    });
  };

  let addSection = async function () {
    jQuery(`#mobile-grid-focus-input`).focus();

    try {
      let resp = await SectionAjax.create(group, {
        name: 'New Section',
      });

      dispatch('added');
      close();

      if (sectionsStore.length == 0) {
        recsStore.set(await RecAjax.fetch(group)); // a new section puts rec objects in "other" section. We need to retrieve the recs again
        sectionsStore.set(await SectionAjax.fetch(group));
      } else {
        sectionsStore.add(resp);
      }

      setTimeout(async () => {
        await goToSection(resp);
        await goToSection(resp); // incase elements load into view, we need to trigger this again

        var elem = jQuery(`[data-section-id="${resp.id}"]`)
          .closest('.ui-section')
          .find('.ui-section-name')
          .find('.editable-content')[0];

        await BrowserUtils.focusAndHighlight(elem);

        dispatch('added-section', { section: sectionsStore.find(resp.id) });
      }, 0);
    } catch {}
  };
</script>

<style style="text/scss" lang="scss">
  .add-rec-btn {
    &:hover,
    &:active {
      background: #a893f9 !important;
      color: white !important;
    }
  }

  .add-section-btn {
    &:hover,
    &:active {
      background: #ffa222 !important;
      color: white !important;
    }
  }
</style>

<AddRecExternalModal
  showModal={(currentUser && currentUser.copied_demo_user_id && showModal) || addRecModal}
  quizQuestion={quizQuestion}
  mobile={true}
  on:close={(_e) => {
    if (quizQuestion) {
      close();
    } else {
      addRecModal = false;
    }
  }}
  on:added={addedRec}
  backButtonFn={() => {
    if (currentUser && currentUser.copied_demo_user_id) {
      close();
    } else {
      addRecModal = false;
    }
  }} />

{#if !quizQuestion}
  <div class="svelte-modal">
    <Modal
      modalLocation="bottom"
      style="margin-top: 0px !important; margin-bottom: 30px !important;
  border-radius: 16px !important;"
      mobile={true}
      show={currentUser && !currentUser.copied_demo_user_id && showModal}
      on:close={close}
      showCloseButton={true}
      fadeInDuration={200}>
      <div slot="content">
        <div style="display: flex; flex-direction: row; height: 150px;">
          <div
            class="add-rec-btn"
            style="display: flex; flex: 1; flex-shrink: 0; padding: 20px;
        background-color: #EEE9FE; border-radius: 10px; text-align: center;
        margin-right: 10px;"
            on:click={() => (addRecModal = true)}>
            <div
              style="display: flex; flex-align: center; justify-content: center;
          flex: 1; align-items: center; flex-direction: column;">
              <img src="/emojis/purple_star.png" style="height: 41px; width: 41px;" />
              <div style="margin-top: 10px; font-size: 14px; font-weight: 500;">Add Recommendation</div>
            </div>
          </div>

          {#if group && group.permissions && group.permissions.edit}
            <div
              class="add-section-btn"
              style="display: flex; flex: 1; flex-shrink: 0; padding: 20px;
        background-color: #FFF6EC; border-radius: 10px; text-align: center;
        margin-left: 10px;"
              on:click={addSection}>
              <div
                style="display: flex; flex-align: center; justify-content: center;
          flex: 1; align-items: center; flex-direction: column; padding-top:
          10px;">
                <svg width="40" height="46" viewBox="0 0 40 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1 26H16C16.552 26 17 25.552 17 25V1C17 0.448 16.552 0 16
              0H1C0.448 0 0 0.448 0 1V25C0 25.552 0.448 26 1 26ZM1 46H16C16.552
              46 17 45.552 17 45V33C17 32.448 16.552 32 16 32H1C0.448 32 0
              32.448 0 33V45C0 45.552 0.448 46 1 46ZM39 14H24C23.448 14 23
              13.552 23 13V1C23 0.448 23.448 0 24 0H39C39.552 0 40 0.448 40
              1V13C40 13.552 39.552 14 39 14ZM24 46H39C39.552 46 40 45.552 40
              45V21C40 20.448 39.552 20 39 20H24C23.448 20 23 20.448 23 21V45C23
              45.552 23.448 46 24 46Z"
                    fill="url(#paint0_linear)" />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="25.5"
                      y1="32.5"
                      x2="11.5"
                      y2="8.5"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FEAF63" />
                      <stop offset="1" stop-color="#FFCB99" />
                    </linearGradient>
                  </defs>
                </svg>

                <div
                  style="margin-top: 10px; font-size: 14px; font-weight: 500; cursor:
            pointer;">
                  New Section
                </div>
              </div>
            </div>
          {/if}
        </div>
      </div>
    </Modal>
  </div>
{/if}
